import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import LogoMark from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-5 pt-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-lg w-full text-center border border-white/10 bg-[#111114] p-10 md:p-14"
      >
        <LogoMark className="h-10 w-10 mx-auto mb-8" />
        <XCircle className="h-12 w-12 text-white/40 mx-auto" />
        <h1 className="font-display font-black text-4xl tracking-tight mt-6">
          CHECKOUT <span className="text-outline">CANCELLED.</span>
        </h1>
        <p className="text-sm text-white/50 mt-4 leading-relaxed">
          No charge was made. Your bag is still packed and waiting whenever you're ready.
        </p>
        <Link
          to="/shop"
          data-testid="return-to-shop-button"
          className="mt-8 inline-flex items-center justify-center bg-[#D3FF24] text-[#0A0A0C] px-8 py-4 text-xs font-bold tracking-[0.25em] hover:bg-[#BEE61B] transition-colors"
        >
          RETURN TO THE ARSENAL
        </Link>
      </motion.div>
    </main>
  );
}
